import { render, staticRenderFns } from "./DemostrativoConteudoLecionado.vue?vue&type=template&id=12ccd28f&"
import script from "./DemostrativoConteudoLecionado.vue?vue&type=script&lang=js&"
export * from "./DemostrativoConteudoLecionado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports